import { render, staticRenderFns } from "./handleRole.vue?vue&type=template&id=2ba33a46&"
import script from "./handleRole.vue?vue&type=script&lang=js&"
export * from "./handleRole.vue?vue&type=script&lang=js&"
import style0 from "./handleRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "handleRole.vue"
export default component.exports